import { NextPage } from 'next'
import dynamic from 'next/dynamic'
import { getIDeviceComponent } from '@ucheba/utils/helpers/components'
import { IObjectDevicesComponents } from '@ucheba/utils/helpers/components/types'
import React from 'react'
import { NextSeo } from 'next-seo'
import { IProfPageProps } from './types'
import Custom404 from '../../404.page'

const devicesPages: IObjectDevicesComponents = {
  desktop: dynamic(() => import('./desktop')),
  touch: dynamic(() => import('./touch')),
}

const ProfPage: NextPage<IProfPageProps> = (props) => {
  const { content, canonical, notFound } = props

  if (notFound) {
    return <Custom404 />
  }

  return (
    <>
      <NextSeo
        title={`${content.seo.title} — Учёба.ру`}
        description={content.seo.description}
        canonical={canonical}
        openGraph={{
          images: [
            {
              url: '',
              width: 1200,
              height: 630,
            },
          ],
        }}
      />

      {getIDeviceComponent(props, devicesPages)}
    </>
  )
}

export default ProfPage
